import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("gb_admin_token", data.token);
      localStorage.setItem("gb_admin_email", data.email);
      toast.success("Bejelentkezés sikeres");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Hibás email vagy jelszó");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF8F3] paper-grain flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <span className="font-mono-brand font-black tracking-[0.22em] text-[#2C221E] text-lg inline-flex items-center">
            <span className="text-[#4A6B53]">●</span>
            <span className="ml-2">GROWBAG</span>
            <span className="ml-2 text-[10px] font-normal tracking-[0.3em] text-[#8C8075]">ADMIN</span>
          </span>
        </div>
        <form onSubmit={submit} className="rounded-3xl bg-white border border-[#2C221E]/10 p-8 shadow-[0_30px_60px_-20px_rgba(44,34,30,0.15)]">
          <h1 className="text-2xl font-bold text-[#201B18]">Bejelentkezés</h1>
          <p className="text-sm text-[#8C8075] mt-1">Csak jogosult felhasználók számára.</p>

          <div className="mt-6 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Jelszó</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" required />
            </div>
            <Button type="submit" disabled={loading} data-testid="admin-login-button" className="w-full h-11 bg-[#2C221E] hover:bg-[#1a1310] text-[#FBF8F3] rounded-full">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Belépés"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
